import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import ShareIcon from '@mui/icons-material/IosShare';
import EventIcon from '@mui/icons-material/Event';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { momentParse } from '../../utils/time';
import ShareButton from '../share-buttons';
import { eventPath } from '../../utils/slugify';
import AddToCalendar from './add-to-calendar';
import EventEditDropdown from './edit-dropdown';
import type { Event } from '../../types/Event';
import type { Group } from '../../types/Group';

type Props = {
  event: Event;
  group?: Group;
};

const EventListingActions = ({ event, group }: Props) => {
  const momentStartAt = event.startAt ? momentParse(event.startAt, event.timezone) : null;

  return (
    <Box sx={{ display: 'flex', ml: 'auto', flexShrink: 0, gap: 0.5 }}>
      <ShareButton
        title={`${event.name}${momentStartAt ? ` on ${momentStartAt.format('ddd, MMMM D, YYYY')}` : ''}`}
        path={eventPath(event.id, event.name)}
        buttonComponent={IconButton}
        size="small"
        tooltip="Share"
      >
        <ShareIcon fontSize="small" />
      </ShareButton>
      <AddToCalendar
        event={event}
        buttonComponent={IconButton}
        size="small"
        tooltip="Add to Calendar"
      >
        <EventIcon fontSize="small" />
      </AddToCalendar>
      {event.permissions && event.permissions.editable && (
        <EventEditDropdown
          event={event}
          group={group}
          buttonComponent={IconButton}
          size="small"
          tooltip="Edit"
        >
          <EditOutlinedIcon fontSize="small" />
        </EventEditDropdown>
      )}
    </Box>
  );
};

export default EventListingActions;
